import DebugService from '../service/DebugService';
export const getSubject = (item) => {
    return new Promise((resolve, reject) => {
        var _a;
        try {
            if (typeof ((_a = item.subject) === null || _a === void 0 ? void 0 : _a.getAsync) === 'function') {
                item.subject.getAsync((res) => {
                    if (res.status === Office.AsyncResultStatus.Succeeded) {
                        const subject = res.value || '';
                        // Ensure we always return a string
                        resolve(String(subject));
                    }
                    else {
                        DebugService.error('getSubject (compose mode) failed');
                        // Return empty string instead of rejecting to prevent crashes
                        resolve('');
                    }
                });
            }
            else {
                const subject = item.subject || '';
                // Ensure we always return a string
                resolve(String(subject));
            }
        }
        catch (error) {
            DebugService.error('getSubject error');
            // Return empty string instead of rejecting to prevent crashes
            resolve('');
        }
    });
};
export const getSender = (item) => {
    return new Promise((resolve, reject) => {
        var _a, _b;
        try {
            if (typeof ((_a = item.from) === null || _a === void 0 ? void 0 : _a.getAsync) === 'function') {
                item.from.getAsync((res) => {
                    var _a;
                    if (res.status === Office.AsyncResultStatus.Succeeded) {
                        const sender = ((_a = res.value) === null || _a === void 0 ? void 0 : _a.emailAddress) || Office.context.mailbox.userProfile.emailAddress;
                        // Ensure we always return a string
                        resolve(String(sender));
                    }
                    else {
                        DebugService.error('getSender (compose mode) failed');
                        // Return user email instead of rejecting to prevent crashes
                        resolve(String(Office.context.mailbox.userProfile.emailAddress));
                    }
                });
            }
            else {
                const sender = ((_b = item.from) === null || _b === void 0 ? void 0 : _b.emailAddress) || Office.context.mailbox.userProfile.emailAddress;
                // Ensure we always return a string
                resolve(String(sender));
            }
        }
        catch (error) {
            DebugService.error('getSender error');
            // Return user email instead of rejecting to prevent crashes
            resolve(String(Office.context.mailbox.userProfile.emailAddress));
        }
    });
};
export const getCreatedDate = (item) => {
    return new Promise((resolve) => {
        const dt = item.dateTimeCreated;
        resolve(dt ? new Date(dt).toISOString() : new Date().toISOString());
    });
};
export const getToRecipients = (item) => {
    return new Promise((resolve) => {
        try {
            const recipients = item.to || [];
            const emails = recipients
                .map((recipient) => recipient.emailAddress)
                .filter(Boolean)
                .join(";");
            DebugService.debug('getToRecipients');
            resolve(String(emails));
        }
        catch (error) {
            DebugService.error('getToRecipients error');
            // Return user email instead of rejecting to prevent crashes
            resolve(String(Office.context.mailbox.userProfile.emailAddress));
        }
    });
};
export const getInternetMessageId = (item) => {
    return new Promise((resolve) => {
        // First try to get it directly from the item
        const directMessageId = item.internetMessageId;
        if (directMessageId) {
            resolve(directMessageId);
            return;
        }
        // If not available directly, try to get it from internet headers
        if (item.internetHeaders && typeof item.internetHeaders.getAsync === 'function') {
            item.internetHeaders.getAsync(['Message-ID'], (result) => {
                if (result.status === Office.AsyncResultStatus.Succeeded) {
                    const messageId = result.value && result.value['Message-ID'];
                    resolve(messageId || null);
                }
                else {
                    resolve(null);
                }
            });
        }
        else if (typeof item.getAllInternetHeadersAsync === 'function') {
            // Fallback: get all headers and parse Message-ID
            item.getAllInternetHeadersAsync((result) => {
                if (result.status === Office.AsyncResultStatus.Succeeded) {
                    const headers = result.value || '';
                    const match = headers.match(/^Message-ID:\s*(.+)$/im);
                    const messageId = match ? match[1].trim() : null;
                    resolve(messageId);
                }
                else {
                    resolve(null);
                }
            });
        }
        else {
            resolve(null);
        }
    });
};
/**
 * Detects if the current email is from a shared mailbox
 * @param item The Office.js mailbox item
 * @returns Promise<{isShared: boolean, mailboxEmail?: string}> - Whether it's shared and the mailbox email
 */
export const detectSharedMailbox = (item) => {
    return new Promise((resolve) => {
        try {
            // Get the current user's email address
            const currentUserEmail = Office.context.mailbox.userProfile.emailAddress;
            // Use Office.js API to detect shared mailbox
            if (typeof item.getSharedPropertiesAsync === 'function') {
                item.getSharedPropertiesAsync((result) => {
                    if (result.status === Office.AsyncResultStatus.Succeeded && result.value) {
                        // This is a shared mailbox - get the owner's email
                        const sharedProperties = result.value;
                        const mailboxEmail = sharedProperties.owner || sharedProperties.targetMailbox || currentUserEmail;
                        resolve({
                            isShared: true,
                            mailboxEmail: mailboxEmail
                        });
                    }
                    else {
                        // Not a shared mailbox or API not supported
                        DebugService.debug('Personal mailbox detected or getSharedPropertiesAsync not supported');
                        resolve({
                            isShared: false,
                            mailboxEmail: currentUserEmail
                        });
                    }
                });
            }
            else {
                // Fallback: Check if we're in a different context
                // This is a conservative approach for when the API isn't available
                DebugService.debug('getSharedPropertiesAsync not available, assuming personal mailbox');
                resolve({
                    isShared: false,
                    mailboxEmail: currentUserEmail
                });
            }
        }
        catch (error) {
            DebugService.error('Error detecting shared mailbox');
            resolve({
                isShared: false,
                mailboxEmail: Office.context.mailbox.userProfile.emailAddress
            });
        }
    });
};
